module.exports = __webpack_public_path__ + "img/Cypress V4 960x540.2b133228.png";